import React from "react";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import { baseUrl } from "api";
import icon from "assets/images/pdf_icon.png";

// ファイル名の定数
const ADMIN_MANUAL_FILE_NAME = "NiserES-Manual-A.pdf";
const CA_MANUAL_FILE_NAME = "NiserES-Manual-B.pdf";

// ファイルパス
const filePath = fileName => `${baseUrl()}/pdf/${fileName}`;

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1
  },
  main: {
    padding: 20,
    minHeight: 200
  },
  rowWrapper: {
    margin: "100px 0 150px"
  },
  row: {
    margin: "10px auto",
    width: 280
  },
  link: {
    color: theme.palette.link,
    background: `url(${icon})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    paddingRight: 25,
    backgroundSize: 18,
    textDecoration: "none"
  }
});

const ManualDownload = props => {
  const { classes, isAdmin } = props;

  return (
    <Paper className={classes.container}>
      <div className={classes.header}>
        <h2 className={classes.title}>マニュアルダウンロード</h2>
      </div>

      <div className={classes.main}>
        <div className={classes.rowWrapper}>
          {isAdmin && (
            <div className={classes.row}>
              <a
                href={filePath(ADMIN_MANUAL_FILE_NAME)}
                className={classes.link}
                target="_blank"
              >
                NiserES操作マニュアル（管理者）
              </a>
            </div>
          )}

          <div className={classes.row}>
            <a
              href={filePath(CA_MANUAL_FILE_NAME)}
              className={classes.link}
              target="_blank"
            >
              NiserES操作マニュアル
            </a>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(ManualDownload);



// WEBPACK FOOTER //
// ./src/components/ManualDownload.jsx